import { logger } from '@tuic/logger';
import { unstable_cache } from 'next/cache';

import { Oss } from '../../index';
import { CacheTag } from '../../utils';

import type { MasterExcursion } from '../../generated/oss';
import type { Locale } from '@tuic/i18n';

type Options = {
  category?: string;
  difficulty?: string;
  port?: string;
};

const getExcursionsSearchList = async (
  options: Options,
  locale: Locale,
): Promise<MasterExcursion[]> => {
  const { data, error } = await Oss.getExcursionsSearchList({
    query: {
      ...options,
      locale,
    },
  });

  if (error) {
    logger.error(
      `Could not fetch excursion search list data. Locale: ${locale}. Query: ${JSON.stringify(
        options,
      )}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

export const cachedGetExcursionsSearchList = unstable_cache(
  getExcursionsSearchList,
  ['oss', 'getExcursionsSearchList'],
  {
    tags: [
      CacheTag.oss,
      CacheTag.excursionResource,
      CacheTag.getExcursionsSearchList,
    ],
    revalidate: 600,
  },
);
